import * as z from 'zod';

import { DisbursementId, EscrowDueId, LoanId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils/Zod';

export const Disbursement = z.object({
  id: zodBrandedUuid<DisbursementId>(),
  loanId: zodBrandedUuid<LoanId>(),
  total: z.number(),
  type: z.enum(['servicingTransfer', 'escrow', 'payoff', 'forwardPayment', 'paymentAfterPayoff']),
  isReversal: z.boolean(),
  amounts: z.object({
    escrow: z.number(),
    suspense: z.number(), // statement suspense
    futureStatementSuspense: z.number().default(0),
    unappliedSuspense: z.number().default(0),
    principalPrepayment: z.number(),
    principal: z.number().optional().default(0),
    interest: z.number().optional().default(0),
    fee: z.number().optional().default(0),
    reserve: z.number().optional().default(0),
    holdback: z.number().optional().default(0),
  }),
  date: zodJSPlainDate,
  recipient: z.string(),
  transactionId: z.string().optional(),
  status: z.literal('PROCESSED'),
  comment: z.string().optional(),
  escrowDueId: zodBrandedUuid<EscrowDueId>().optional(),
  createdDate: zodJSInstantDate.optional(),
});
export type Disbursement = z.infer<typeof Disbursement>;
